import React, { useState, useEffect } from 'react'
import { Switch } from '@arco-design/web-react'
const UpSeting = () => {
  const [configurationData, setConfigurationData] = useState([
    {
      label: '大纲生成PPT',
      key: 'outlinePPT',
      desc: '可根据用户输入的大纲内容，生成对应的PPT文档',
      enabled: true
    },
    {
      label: '演讲稿生成PPT',
      key: 'speechPPT',
      desc: '将用户输入的演讲稿内容，生成对应的PPT文档',
      enabled: true
    },
    {
      label: '演讲稿生成',
      key: 'speech',
      desc: '将用户输入的内容，生成对应的演讲稿',
      enabled: true
    },
    {
      label: '溯源生成',
      key: 'traceGenerate',
      desc: '根据用户输入的内容，生成对应的可溯源PPT',
      enabled: true
    },
    {
      label: '联网搜索',
      key: 'onlineSearch',
      desc: '可利用联网获取的图片、视频、音频素材资源生成PPT',
      enabled: true
    },
    {
      label: '知识库',
      key: 'knowledgeBase',
      desc: '从知识库中获取相关信息生成PPT',
      enabled: true
    },
    {
      label: 'AI配图',
      key: 'aiImage',
      desc: '可根据内容生成高清配图，形成PPT',
      enabled: true
    }
  ])

  // 处理功能开关切换
  const handleToggle = (key) => {
    console.log('切换功能:', key)
    setConfigurationData(
      configurationData.map((item) =>
        item.key === key ? { ...item, enabled: !item.enabled } : item
      )
    )
  }
  useEffect(() => {
    // 当configurationData更新时，会执行这里的代码,发送网络请求
  }, [configurationData])

  return (
    <div style={styles.rightPanel}>
      <div style={styles.sectionTitle}>功能升级</div>
      <div style={styles.text}>
        以下功能启用后会在编辑器中开启对应的功能入口，功能的使用会按实际调用收取费用，详情请参考产品价格
      </div>
      <div style={styles.featuresList}>
        {configurationData.map((item) => (
          <div key={item.key} style={styles.featureItem}>
            <div style={styles.featureInfo}>
              <div style={styles.featureLabel}>{item.label}</div>
              <div style={styles.featureDesc}>{item.desc}</div>
            </div>
            <Switch
              checked={item.enabled}
              onChange={() => handleToggle(item.key)}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

// 优化后的样式定义
const styles = {
  // 右侧面板样式
  rightPanel: {
    width: '100%',
    backgroundColor: '#fff',
    padding: '20px',
    boxSizing: 'border-box',
    borderRadius: '4px',
    overflow: 'auto'
  },

  // 通用区块样式
  sectionTitleB: {
    marginTop: '30px',
    fontSize: '14px',
    fontWeight: '600',
    marginBottom: '16px',
    color: '#333'
  },

  // 通用区块样式
  sectionTitle: {
    fontSize: '14px',
    fontWeight: '600',
    marginBottom: '16px',
    color: '#333'
  },

  // 配置区块样式
  configSection: {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '12px'
  },

  // 表单样式
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '30px'
  },

  formItem: {
    width: '80%',
    display: 'flex',
    alignItems: 'center'
  },

  formLabel: {
    width: '72px',
    fontSize: '14px',
    color: '#666',
    display: 'flex',
    alignItems: 'center'
  },

  inputWithButtonContainer: {
    display: 'flex',
    gap: '12px', // 输入框和按钮之间的间距
    width: '90%' // 确保整体宽度与其他输入框一致
  },

  formInput: {
    flex: 1, // 让输入框自动占据剩余空间
    padding: '8px 12px',
    border: '1px solid transparent',
    borderRadius: '6px',
    backgroundColor: '#f5f5f5',
    fontSize: '14px',
    height: '36px',
    boxSizing: 'border-box',
    color: '#6e8ece'
  },

  // 按钮样式
  submitButton: {
    padding: '8px 16px',
    backgroundColor: '#165DFF',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
    width: '120px'
  },

  openButton: {
    padding: '8px 16px',
    backgroundColor: '#36D399',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
    width: '120px',
    marginTop: '8px'
  },

  // 功能配置区块样式
  featuresSection: {
    backgroundColor: '#fff',
    padding: '20px 20px 40px 20px',
    borderRadius: '12px',
    flex: 1,
    overflow: 'auto'
  },

  featuresList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px'
  },

  featureItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px',
    backgroundColor: '#fff',
    borderRadius: '4px'
  },

  featureInfo: {
    flex: 1
  },

  featureLabel: {
    fontSize: '14px',
    fontWeight: '600',
    marginBottom: '4px'
  },
  text: {
    fontSize: '12px',
    color: '#666',
    lineHeight: '1.5',
    marginBottom: '16px'
  },
  featureDesc: {
    fontSize: '10px',
    color: '#666',
    maxWidth: '80%'
  },
  // 右侧面板内容样式
  infoText: {
    width: '80%',
    fontSize: '14px',
    color: '#666',
    lineHeight: '1.5',
    marginBottom: '16px',
    padding: '0 24px'
  },
  infoBtn: {
    padding: '10px 14px',
    marginLeft: '16px',
    color: '#406eff',
    borderRadius: '4px',
    border: '1px solid #406eff',
    cursor: 'pointer',
    fontSize: '12px'
  },
  divider: {
    margin: '16px 0'
  },

  // 表格样式
  tableContainer: {
    backgroundColor: '#fff',
    borderRadius: '4px',
    overflow: 'hidden',
    marginBottom: '12px',
    marginTop: '20px',
    border: '1px solid #eee'
  },

  tableHeaderRow: {
    display: 'flex',
    backgroundColor: '#f9f9f9',
    borderBottom: '1px solid #eee',
    textAlign: 'center'
  },

  tableHeaderCell: {
    padding: '10px 12px',
    fontSize: '14px',
    fontWeight: '500',
    color: '#406eff',
    flex: 1,
    textAlign: 'center',
    borderRight: '1px solid #eee',
    '&:last-child': {
      borderRight: 'none'
    }
  },
  tableHeaderCell1: {
    padding: '10px 12px',
    fontSize: '14px',
    backgroundColor: '#f1faff',
    fontWeight: '500',
    color: '#333',
    flex: 1,
    textAlign: 'center',
    borderRight: '1px solid #eee',
    '&:last-child': {
      borderRight: 'none'
    }
  },

  tableRow: {
    display: 'flex'
  },

  tableCellHeader: {
    padding: '10px 12px',
    fontSize: '14px',
    backgroundColor: '#f1faff',
    color: '#333',
    fontWeight: '500',
    flex: 1,
    textAlign: 'center',
    borderRight: '1px solid #eee',
    borderBottom: '1px solid #eee'
  },

  tableCell: {
    padding: '10px 12px',
    fontSize: '14px',
    color: '#666',
    flex: 1,
    textAlign: 'center',
    borderRight: '1px solid #eee',
    borderBottom: '1px solid #eee',
    '&:last-child': {
      borderRight: 'none'
    }
  },

  tableNote: {
    fontSize: '12px',
    color: '#999',
    marginTop: '8px'
  }
}

export default UpSeting
